import { api } from '@/scripts/api';

export const ScheduledReportService = {

    get(id, config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/ScheduledReports';

            const endpoint = api.applyODataParams(service, {
                ...config,
                filter: `Id eq ${ id }`,
            });

            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);
        });
    },

    getAll(config = {}, signal) {
        return new Promise((resolve, reject) => {

            const service = '/service/ScheduledReports';

            const endpoint = api.applyODataParams(service, config);

            api
                .get(endpoint, signal)
                .then(resolve)
                .catch(error => {
                    if (!api.isCanceled(error)) {
                        reject(error);
                    }
                });
        });
    },

    getTypes(config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/ReportTypes';

            const endpoint = api.applyODataParams(service, config);

            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);
        });
    },

    getFrequencyTypes() {
        return new Promise((resolve, reject) => {
            const service = '/service/ReportFrequencyTypes';

            api
                .get(service)
                .then(resolve)
                .catch(reject);
        });
    },

    post(payload) {
        return new Promise((resolve, reject) => {
            api
                .post('/api/ScheduledReports', payload)
                .then(resolve)
                .catch(reject);
        });
    },

    patch(id, payload) {
        return new Promise((resolve, reject) => {
            const service = `/api/ScheduledReports/${ id }`;

            api.patch(service, payload)
                .then(resolve)
                .catch(reject);
        });
    },

    delete(id) {
        return new Promise((resolve, reject) => {
            const service = `/api/ScheduledReports/${ id }`;

            api
                .delete(service)
                .then(resolve)
                .catch(reject);
        });
    },
}
